import { FormHelperText, InputLabel, Stack } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useField, useFormikContext } from 'formik';
import { useState } from 'react';

export const DayJsDatePicker = (
    { id, name, minDate, maxDate, disabled }:
        {
            id: string; name: string;
            minDate: string, maxDate: string, disabled: boolean
        }
) => {
    const currentDate = dayjs();
    const [dates, setDates] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));
    const formikContext = useFormikContext();
    const [field, meta, { setValue }] = useField(name);
    const [error, setError] = useState(false);
    // const onChange = (date: any) => {
    //     date == 'Invalid Date' && setError(true);
    //     date != 'Invalid Date' && setError(false);
    //     setValue(date);
    // };
    const errorText = error ? 'Invalid Date' : meta.error && meta.touched ? meta.error : '';

    return (
        <Stack>
            <InputLabel
                shrink
                htmlFor={id}
                sx={{
                    transform: 'unset',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'rgba(0,0,0,0.7)',
                    mb: 1.8
                }}>
                DOB (MM/DD/YYYY)
            </InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>

                <DatePicker
                    label=""
                    value={dayjs(dates)}
                    name={name}
                    minDate={dayjs(minDate)}
                    maxDate={dayjs(maxDate)}
                    disabled={disabled}
                    onChange={(date: any) => {
                        setDates(date.format("YYYY-MM-DD"));
                        formikContext.setFieldValue('dob', date.format("YYYY-MM-DD"));
                    }
                    }
                    sx={{
                        fontSize: 14,
                        fontWeight: 500,
                        p: -3
                    }}
                />
            </LocalizationProvider>
            {errorText && (
                <FormHelperText error sx={{ marginLeft: 'unset' }}>
                    {errorText}
                </FormHelperText>
            )}
        </Stack>
    )
}

export const MinorDayJsDatePicker = (
    { id, name, label, minDate, maxDate, previousDob, setMinorDataFetched }:
        {
            id: string; name: string; label: string, maxDate?: string;
            minDate?: string;
            disabled?: boolean;
            previousDob?: any;
            setMinorDataFetched?: any;
        }
) => {
    const formikContext = useFormikContext();
    const [field, meta, { setValue }] = useField(name);
    const [error, setError] = useState(false);
    const errorText = error ? 'Invalid Date' : meta.error && meta.touched ? meta.error : '';

    return (
        <Stack>
            <InputLabel
                shrink
                htmlFor={id}
                sx={{
                    transform: 'unset',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'rgba(0,0,0,0.7)',
                    my: 1.7
                }}>
                {label}
            </InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>

                <DatePicker
                    label=""
                    value={dayjs(field.value)}
                    name={name}
                    minDate={dayjs(minDate)}
                    maxDate={dayjs(maxDate)}

                    onChange={(date: any) => {
                        setValue(date.format("YYYY-MM-DD"));

                        formikContext.setFieldValue(`${name}`, date.format("YYYY-MM-DD"));
                        if (
                            date != 'Invalid Date' && previousDob &&
                            new Date(date).toISOString() !== new Date(previousDob).toISOString()

                        ) {
                            setMinorDataFetched('changed');
                        } else {
                            setMinorDataFetched('fetched');
                        }
                    }
                    }

                    slotProps={{
                        textField: {
                            fullWidth: true,
                            id: "date-picker-input",

                            sx: {

                                '& .MuiInputBase-root': {
                                    border: '1px solid #DDEAF3',
                                },
                                '& .MuiOutlinedInput-root': {
                                    position: 'relative',
                                    backgroundColor: 'common.white',
                                    border: '1px solid #DDEAF3',
                                    fontSize: 16,
                                    '&:hover': {
                                        borderColor: 'primary.main',
                                        '.MuiOutlinedInput-notchedOutline': {
                                            border: 0,
                                        },
                                    },
                                    '.MuiOutlinedInput-notchedOutline': {
                                        border: 0,
                                    },
                                    '.MuiInputBase-input': {
                                        p: '10px 12px',
                                    },
                                    '&:focus-visible': {
                                        outline: 'none',
                                    },
                                },
                                display: 'flex',
                                flexDirection: 'row-reverse',
                            },

                        },
                    }}
                />
            </LocalizationProvider>
            {errorText && (
                <FormHelperText error sx={{ marginLeft: 'unset' }}>
                    {errorText}
                </FormHelperText>
            )}
        </Stack>
    )
}
